.successMessageContainer {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.successActionLink {
  color: var(--content-success);
  text-decoration: none;
  font: var(--label-sm-font);
  letter-spacing: var(--label-sm-letter-spacing);
}
